/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'



import { useAuth } from '../auth';
import { BLACKBOXES_BLACKBOX_GRAPHIC_GET_WEIGHT_OF_INDICATOR_DATETIME_URL, BLACKBOXES_BLACKBOX_GRAPHIC_GET_WEIGHT_OF_INDICATOR_URL, GET_INDICATOR_WEIGHT_FOR_PREDICTIVEMAINTANCE, } from '../../../urls';
import { useLocation } from 'react-router-dom';
import { IndicatorWeightLabel } from './Indicator/IndicatorWeightLabel';
import { Line } from 'react-chartjs-2';
import { Button, ButtonGroup } from 'react-bootstrap';



export function IndicatorMainWindow() {

  const { currentUser, logout } = useAuth()
  const location = useLocation();
  const uid = (location.state as { uid?: string })?.uid;
  const [indicatorWeight, setIndicatorWeight] = useState<any>([])
  const [isIndicator, setIsIndicator] = useState(true)
  const [deviceType, setDeviceType] = useState("2")

  /**
   * Grafik araligi: "1" gunluk, "2" aylik, "3" yillik.
   *
   * ADI DEGISTI. Eskiden `const [interval, setInterval] = useState("1")` idi ve
   * `setInterval` GLOBAL `window.setInterval`'i GOLGELIYORDU: bu dosyada bir
   * zamanlayici kurmak isteyen biri sessizce state'i yazardi. Bu, depoda
   * defalarca karsilastigimiz "ayni ad, baska anlam" tuzaginin kendisi.
   */
  const [aralik, setAralik] = useState("1")
  const [graphicData, setGraphicData] = useState<any>([])
  const [resetChart, setResetChart] = useState(false)
  const [initializePage, setInitializePage] = useState(false)
  /** Veri alinamadiysa ekranda sebebi yaziyor. */
  const [hata, setHata] = useState<string | null>(null)
  /**
   * Ozet istegi DONDU mu?
   *
   * Baslangic durumu da `[]` oldugu icin bu bayrak olmadan "veri yok" uyarisi
   * istek donmeden bir an PARLIYOR. Her acilista parlayan bir uyari,
   * okunmayan bir uyaridir.
   */
  const [ozetYuklendi, setOzetYuklendi] = useState(false)
  const handleInterval = (parametre: string) => { setAralik(parametre) }
  const createHeader = () => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', "" + token?.toString());
    return headers
  }
  const token = currentUser?.token



  useEffect(() => {
    // `uid` location.state'ten geliyor; adrese dogrudan girildiginde (ya da
    // sayfa yenilendiginde) bos olur ve eskiden `?uid=undefined` istegi
    // gidiyordu.
    if (!uid) {
      return
    }
    getweightofindicator()
    if(initializePage === false){
      getIndicatorWeight()
      
      setInitializePage(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aralik, uid])


  /**
   * Ozet yuk degerleri (toplam, en yuksek, son).
   *
   * Onceden ne `ok`, ne 401, ne `catch` vardi: sunucu hata dondurdugunde hata
   * govdesi dogrudan `indicatorWeight`e yaziliyor ve ekran "bilinmiyor"
   * gosteriyordu -- "olcum yok" ile "istek basarisiz" ayirt edilemiyordu.
   */
  async function getIndicatorWeight() {
    try {
      const response = await fetch(GET_INDICATOR_WEIGHT_FOR_PREDICTIVEMAINTANCE + `?uid=${uid}`, {
        method: "GET",
        headers: createHeader()
      })
      if (response.status === 401) { logout(); return }
      // 404 = bu cihaz icin henuz toplam yuk kaydi YOK. Hata degil: kayit
      // ancak tamamlanmis bir kaldirma geldiginde olusuyor.
      if (response.status === 404) { setIndicatorWeight([]); return }
      if (!response.ok) { throw new Error(`HTTP ${response.status}`) }

      const res = await response.json()
      setIndicatorWeight(res && typeof res === 'object' ? res : [])
      if (res && res["sumLoad2"] != null) {
        setIsIndicator(false)
        setDeviceType("1")
      }
      setHata(null)
    } catch (e) {
      console.error("Indikator yuk ozeti alinamadi:", e)
      setHata(e instanceof Error ? e.message : "bilinmeyen hata")
    } finally {
      // Tek yerde: `finally` erken `return`larda da kosuyor, yani butun yollar
      // kapsaniyor. Dallara tek tek yazmak, yeni bir dal eklendiginde unutulan
      // bir satir birakirdi.
      setOzetYuklendi(true)
    }
  }

  // getIndicatorRopeRate KALDIRILDI (2026-10-02).
  //
  // /api/predictivemaintenance/getroperate ucunu cagiriyordu, ama o uc 2024-11-29'da
  // commit 3277b95 ("removed rope analysis") ile backend'den kaldirilmis. Yani cagri
  // bir yildir 404 doneriyordu ve her sayfa acilisinda useEffect'ten tetikleniyordu.
  //
  // Zaten islevsizdi: yanitin .then govdesi bostu, donen veri hicbir yere yazilmiyordu.
  /**
   * Grafik verisi. Gunluk ayri bir uctan geliyor (tarih kirilimli), aylik ve
   * yillik digerinden.
   *
   * IKI DAL TEK GOVDEYE INDI: ayni 18 satir iki kez yaziliydi ve tek fark
   * URL'ydi. Ikisinde de ne `ok`, ne 401, ne `catch` vardi -- ve bu, asagidaki
   * cizim kodunda KESIN BIR COKME yoluna aciliyordu: sunucunun hata govdesi
   * (`{timestamp, status, error, path}`) `graphicData`ya yaziliyor, sonra
   * `graphicData["date"].length` okunuyor ve sayfa BEYAZ kaliyordu.
   */
  async function getweightofindicator() {
    const url = aralik === "1"
      ? BLACKBOXES_BLACKBOX_GRAPHIC_GET_WEIGHT_OF_INDICATOR_DATETIME_URL
      : BLACKBOXES_BLACKBOX_GRAPHIC_GET_WEIGHT_OF_INDICATOR_URL

    try {
      const response = await fetch(url + `?uid=${uid}&deviceType=${deviceType}&interval=${aralik}`, {
        method: "GET",
        headers: createHeader()
      })
      if (response.status === 401) { logout(); return }
      if (response.status === 404) { setGraphicData([]); setResetChart(false); return }
      if (!response.ok) { throw new Error(`HTTP ${response.status}`) }

      const res = await response.json()
      setGraphicData(res)
      setResetChart(false)
      setHata(null)
    } catch (e) {
      console.error("Indikator grafik verisi alinamadi:", e)
      // Bozuk yanit cizime GIRMIYOR: bos dizi guvenli varsayilan.
      setGraphicData([])
      setHata(e instanceof Error ? e.message : "bilinmeyen hata")
    }
  }
  /**
   * Cizim verisi.
   *
   * ESKI KOD KESIN OLARAK COKUYORDU:
   *
   *     graphicData["date"].length != 0 && Array.isArray(graphicData["date"])
   *
   * `.length` ONCE okunuyor, dizi mi diye SONRA bakiliyor. Alan yoksa
   * `undefined.length` -> TypeError -> sayfa BEYAZ. Bu kuramsal degildi:
   * ustteki fetch'lerde `ok` denetimi olmadigi icin sunucunun hata govdesi
   * dogrudan `graphicData`ya yaziliyordu ve o nesnede `date` yok. Yani uctan
   * gelen HER hata sayfayi dusuruyordu.
   *
   * Sira duzeltildi ve uc ayni kontrol tek yardimciya indi.
   */
  const dizi = (alan: string): any[] => {
    const deger = !Array.isArray(graphicData) ? graphicData?.[alan] : undefined
    return (resetChart === false && Array.isArray(deger) && deger.length !== 0) ? deger : [0, 0, 0]
  }

  let labels: any = dizi("date")
  let labelsData: any = dizi("label1")
  let labels2Data: any = dizi("label2")
  let data = {
    labels,
    datasets: [
      // {
      //   label: "Tarih",
      //   data: labels.map(() =>[0, labelsData.splice(0, 1)]),
      //   backgroundColor: 'rgba(255, 99, 132, 0.5)',
      //   borderColor: 'rgb(53, 162, 235)',
      // },
      {
        label: "Yük-1",
        data: labelsData.length !== 0 ? labels.map(() => [0, labelsData.splice(0, 1)]) : [],
        borderColor: 'rgb(53, 162, 235)',
        fill: false,
      },
      {
        label: "Yük-2",
        data: labels2Data.length !== 0 ? labels.map(() => [0, labels2Data.splice(0, 1)]) : [],
        borderColor: "rgba(255, 99, 132, 1)",
        fill: false,
      },

    ],
  };

  return (


    <>
      {/* Hata ARTIK GORUNUYOR. State'i eklemek yetmiyordu: yazilip hic
          okunmayan bir state, bu depoda tekrar tekrar duzelttigim kusurun
          kendisi (loading, variant, showAlert...). */}
      {hata && (
        <div className='alert alert-danger'>
          İndikatör verisi alınamadı ({hata}).
        </div>
      )}

      {!uid && (
        <div className='text-muted p-4'>
          Cihaz seçilmedi. Bu ekrana Vinç Analiz listesindeki
          <strong> Yük Kontrol Sistemleri </strong> bölümünün okundan geliniyor.
        </div>
      )}

      {(indicatorWeight.length !== 0) &&
        <div className='row g-5 g-xl-8'>
          <div className='col-xl-4'>
            <IndicatorWeightLabel
              className='card-xl-stretch mb-xl-8'
              svgIcon='basket'
              color='body-white'
              iconColor='primary'
              titleColor='gray-900'
              descriptionColor='gray-400'
              showData={indicatorWeight["sumLoad1"]}
              explanation="Toplam Taşınan Yaklaşık Yük"
              explanation1={indicatorWeight["lastDateForLoad1"]}
            />
          </div>
          <div className='col-xl-4'>
            <IndicatorWeightLabel
              className='card-xl-stretch mb-xl-8'
              svgIcon='basket'
              color='body-white'
              iconColor='primary'
              titleColor='gray-900'
              descriptionColor='gray-400'
              showData={indicatorWeight["maxWeightLoad1"]}
              explanation="En Yüksek Taşınan Yük"
              explanation1={indicatorWeight["maxWeighDatetForLoad1"]}
            />
          </div>
          <div className='col-xl-4'>
            <IndicatorWeightLabel
              className='card-xl-stretch mb-xl-8'
              svgIcon='basket'
              color='body-white'
              iconColor='primary'
              titleColor='gray-900'
              descriptionColor='gray-400'
              showData={indicatorWeight["lastWeightLoad1"]}
              explanation="Son Taşınan Yük"
              explanation1={indicatorWeight["lastDateForLoad1"]}
            />
          </div>
          
          {
            isIndicator === false &&
            <>
              <div className='col-xl-4'>
                <IndicatorWeightLabel
                  className='card-xl-stretch mb-xl-8'
                  svgIcon='basket'
                  color='body-white'
                  iconColor='primary'
                  titleColor='gray-900'
                  descriptionColor='gray-400'
                  showData={indicatorWeight["sumLoad2"]}
                  explanation="Toplam Taşınan Tahmini Yük"
                  explanation1={indicatorWeight["lastDateForLoad2"]}
                />
              </div>

            </>

          }

        </div>
      }

      {/* VERI YOK durumu ARTIK SOYLENIYOR.
          404 geldiginde `setIndicatorWeight([])` yapiliyordu ve hicbir mesaj
          cikmiyordu: kullanici bos bir sayfa gorup "sayfa acilmiyor" diye
          okuyordu. "Veri yok" ile "ekran bozuk" ayirt edilemiyordu -- bu
          depoda tekrar tekrar duzelttigim kalibin aynisi. */}
      {uid && !hata && ozetYuklendi && indicatorWeight.length === 0 && (
        <div className='alert alert-warning'>
          <strong>Bu indikatör için henüz toplam yük kaydı yok.</strong>
          <div className='mt-2 fs-7'>
            Kayıt, cihazdan <em>tamamlanmış bir kaldırma</em> geldiğinde
            oluşuyor (yük kancaya binip bırakıldığında). Cihaz yeni takıldıysa
            ya da hiç kaldırma yapılmadıysa bu normal. Aşağıdaki grafik kendi
            verisini ayrıca çekiyor.
          </div>
        </div>
      )}

      {/* GRAFIK ARTIK OZETE BAGLI DEGIL.
          Oncesinde bu bolum `indicatorWeight.length !== 0` blogunun ICINDE
          duruyordu, yani toplam yuk kaydi yoksa grafik -- kendi "Data
          bulunamadi" mesaji ve aralik dugmeleriyle birlikte -- tamamen
          kayboluyordu. Iki ayri veri kaynagi tek kosula baglanmisti. */}
      {uid &&
          <div className="container">
            <div className="row">
              <div className="col offset-md-2">
                <h2>Tahmini Taşınan Yük</h2>

                <div className="chart-container pl-3" style={{ height: '95%', width: '80%' }}>
                  {(!Array.isArray(graphicData) &&  data["labels"].length > 0) ?
                    <Line data={data} />
                    : "Data bulunamadı"}
                  <div className="row justify-content-center">
                    <ButtonGroup aria-label="Basic example">
                      <Button
                        variant="secondary"
                        onClick={() => handleInterval("1")}>Günlük</Button>
                      <Button
                        variant="secondary"
                        onClick={() => handleInterval("2")}>Aylık</Button>
                      <Button
                        variant="secondary"
                        onClick={() => handleInterval("3")}>Yıllık</Button>
                    </ButtonGroup>
                  </div>
                </div>

              </div>
            </div>
          </div>
      }
    </>

  )
}
